<template lang="pug">
  .container-login
    .withdrawBox(v-if="wallet_status == 0")
      h1.align-center 富力钱包提现
      el-form(label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="提现金额", required)
          span {{realAmout | toYuan}} 元
        el-form-item(label="手机号验证", required)
          span(style="margin-right:30px") {{security_tel | desensitization}} 
        //-   el-button(type="primary",@click="sendVerifyCode",v-if="!verify_locked") 获取验证码
        //-   span(v-else) {{countdown}}S
        el-form-item(label="验证码", required)
          el-input(v-model="verify_code")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="smsConfirm()") 确定
        //- el-button(@click="close") 取消
    div.withdraw-success(v-else)
      .success
      h2 已提交至银行系统处理
      
    footer.container-copyright-login
      .copyright-content ©2018-2021Guangzhou ThinkinPower Internet Technology Co., Ltd. 版权所有 广州市思力智慧互联网科技有限公司
      .copyright-content 粤ICP备16101578号 粤公网安备44010602001961号
    //- el-dialog(title="关于系统升级维护的公告" :visible="isShow" width="50%" :center="true" class="gl-tip")
    //-     div
    //-         div 尊敬的用户：
    //-         p &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为更好的服务广大用户，我司将于2020年6月12日下午14:00至23:59进行系统升级维护。由此给您带来的不便，我们深表歉意，并将尽快恢复对您的服务，衷心感谢您对我司的理解和支持！
    //-         .txt-right 广州市思力智慧互联网科技有限公司
    //-         .txt-right 2020年6月12日
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      realAmout: 0,
      wallet_id: null,
      security_tel: '',
      verify_locked: false,
      countdown: -1,
      verify_code: '',
      settle_id: '',
      ticket: '',
      wallet_status: 0
    }
  },
  computed: {
    // isMobile() {
    //   return window.browserInfo.isMobile;
    // },
  },
  methods: {
    // close() {},
    sendVerifyCode() {
      if (this.realAmout <= 0) {
        this.$message({
          type: 'error',
          message: `提现金额必须大于0`
        })
        return
      }
      if (!this.wallet_id) {
        this.$message({
          type: 'error',
          message: `钱包id出错，无法提现`
        })
        return
      }
      const params = {
        amount: this.realAmout,
        wallet_id: this.wallet_id
        // jump_url: "http://www.baidu.com"
      }
      this.$store
        .dispatch('WITHDRAW', params)
        .then(data => {
          this.ticket = data.ticket
          this.startCountdown()
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: 'error',
            message: `提现失败。${code}：${msg}`
          })
        })
    },
    smsConfirm() {
      if (!this.verify_code) {
        this.$message({
          type: 'error',
          message: `请输入验证码！`
        })
        return
      }
      const params = {
        ticket: this.ticket,
        verify_code: this.verify_code
      }
      this.$store
        .dispatch('SMS_CONFIRM', params)
        .then(data => {
          this.$message({
            type: 'success',
            message: `已提交至银行系统处理。`
          })
          this.wallet_status = 1
          //   this.$route.query.wallet_status = 1
          this.$router.push({
            path: this.$route.path,
            query: { wallet_status: 1 }
          })
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: 'error',
            message: `提交失败。${code}：${msg}`
          })
        })
    },
    getWalletInfo() {
      // 当前的钱包状态
      this.$store
        .dispatch('GET_WALLET_INFO', {
          settle_id: this.settle_id
        })
        .then(res => {
          this.wallet_id = res.wallet_tunnel.wallet_id
          this.security_tel = res.wallet_tunnel.security_tel
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: 'error',
            message: `获取钱包失败。${code}：${msg}`
          })
        })
    },
    startCountdown() {
      this.verify_locked = true
      this.countdown = 60
      const t = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.countdown = 0
          this.verify_locked = false
          clearInterval(t)
        }
      }, 1000)
    }
  },
  async mounted() {
    this.settle_id = this.$route.params.settle_id
    this.realAmout = Number(this.$route.params.amount)
    this.ticket = this.$route.params.ticket
    this.wallet_status = this.$route.query.wallet_status
      ? this.$route.query.wallet_status
      : 0
    try {
      await this.$store.dispatch('GET_USER_INFO')
      await this.getWalletInfo()
    } catch (err) {
      this.$message({
        type: 'error',
        message: `提现出错${JSON.stringify(err)}`
      })
    }
  }
}
</script>

<style lang="less">
@import (reference) '../assets/general';

.container-login {
  .flex(center, center, column);
  .max-width;
  .max-height;

  background: url('../assets/bg_login.jpg') center center no-repeat;
  background-size: cover;

  .login-title {
    font-size: 36px;
    font-weight: normal;
    color: @white;
    .align-center;
  }
  .withdrawBox,
  .withdraw-success {
    h1 {
      color: #000;
      padding: 10px;
    }
    .border-box;
    width: 400px;
    margin: 2em auto;
    padding: 20px;

    background: @white;
    border-radius: 4px;
  }

  .login-btn {
    .max-width;
  }

  .container-copyright-login {
    .border-box;
    .flex(center, space-between);
    .max-width;
    .align-center;
    .position-absolute;
    bottom: 0%;

    padding: 1em;
    font-size: 12px;
    color: @white;

    @media screen and (max-width: 500px) {
      .flex(center, space-between, column);
    }
  }

  .forgetPassword {
    font-size: 12px;
    margin: 0.5em 0;
    color: @background-blue;

    &:hover {
      color: @background-blue-active;
    }
  }

  .el-input {
    margin-bottom: 20px;
  }

  .withdrawBox .el-tabs__nav {
    margin-left: 0;
  }

  .withdraw-success {
    text-align: center;
    .success {
      background-image: url('/success.png');
      background-size: 100%;
      width: 80px;
      height: 80px;
      margin: 20px auto;
    }
  }
}
</style>
